import { Tab, Tabs, Typography } from "@mui/material";
import { CustomTabPanel, PageListLayout } from "../../../shared";
import { StockCategories, StockItemTags } from "../components";
import { useLocation, useNavigate } from "react-router-dom";

const breadcrumbs = [
  <Typography key="3" sx={{ fontSize: "14px", fontWeight: 400 }}>
    Stock Categories & Tags
  </Typography>,
];

export const StockCategoriesAndTagsList = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleChange = (event, newValue) => {
    navigate(`/stock-categories-tags${newValue}`);
  };

  return (
    <PageListLayout
      breadcrumbs={breadcrumbs}
      headerText="Stock Categories & Tags"
      tabs={
        <Tabs value={search} onChange={handleChange}>
          <Tab value={""} label="Stock Categories" />
          <Tab value={"?tags"} label="Stock Item Tags" />
        </Tabs>
      }
    >
      <CustomTabPanel value={search} index={""}>
        <StockCategories />
      </CustomTabPanel>
      <CustomTabPanel value={search} index={"?tags"}>
        <StockItemTags />
      </CustomTabPanel>
    </PageListLayout>
  );
};
